module.exports = __webpack_public_path__ + "static/media/CV-anthony lasbleiz Dev.699eddc5.pdf";